import React from 'react';
import PropTypes from 'prop-types';
import Price from './Price';

const PriceTypeExisting = ({ priceType, handleRemoval }) => {
  return (
    <div className="syos-pricetype-unit">
      <span className="syos-pricetype-unit__details">
        <Price priceData={priceType} isStacked={true} />
      </span>
      <span className="syos-pricetype-unit__action">
        <button className="syos-button" onClick={handleRemoval}>
          Remove
        </button>
      </span>
    </div>
  );
};
PriceTypeExisting.propTypes = {
  priceType: PropTypes.shape({
    price_type_desc: PropTypes.string,
    price: PropTypes.string
  }),
  handleRemoval: PropTypes.func
};

export default PriceTypeExisting;



// WEBPACK FOOTER //
// ./src/javascripts/components/PriceTypeExisting.js